<template>
  <div class="infobox">
    <p><b>Willkommen!</b></p>
    <p>Lust eine Runde zu spielen?</p>
    <p>Na dann los!</p>
    <p><b>Schießen:</b> Mit Mausklick oder Touch</p>
    <p><b>Nachladen:</b> Rechtsklick oder "Nachladen"-Button unten links</p>
    <button @click.left="$emit('start-game')">Spiel starten</button>
  </div>
</template>

<script>
  export default {
    name: 'Welcome'
  }
</script>



// WEBPACK FOOTER //
// src/components/Welcome.vue